<template>
  <div class=" text-center inactive-instance">
     <v-row dense class="text-center ma-6 ">
        <v-col cols="12" sm="6" offset-sm="3" class="py-0 mt-0 px-10">
          <img
            src="@/assets/inactive_instance.png"
            class="mx-auto"
            width="60%"
          />
          <img
            src="https://d3jv0cqma81l17.cloudfront.net/images/86328/files/original/logo-cluvi-120.png?1630975397" 
            class="mx-auto my-8"
            width="60%"
          />
        </v-col>
        <v-col cols="12" sm="6" offset-sm="3" class="py-0 mt-0 px-10">
          <v-sheet cla outlined class="pa-3" elevation="2">
            <small class="msge">
              {{ $t('INVALIDATE', {name: instance.name}) }}
            </small>
          </v-sheet>
        </v-col>
        <v-col cols="12" sm="6" offset-sm="3" class="py-2 mt-0">
          <span class="inactive-text" v-html="$t('inactive-instance.inactive')" />
        </v-col>
        <v-col cols="12" sm="6" offset-sm="3" class=" ">
          <v-btn
            color="success"
            block
            class="my-4 btn-text-lowercase rounded-lg" 
            x-large
            href="https://www.cluvi.co/restaurantes"
            target="_blank"
            v-html="$t('inactive-instance.others_restaurants')"
          />
          <v-btn 
            color="cluvi"
            dark
            block
            class="my-4 btn-text-lowercase rounded-lg" 
            x-large
            href="https://servicios.cluvi.co/menu"
            target="_blank"
            v-html="$t('inactive-instance.cluvi_restautants')"
          />

        </v-col>
      </v-row>
  </div>
</template>

<script>
export default {
  name: 'InactiveInstance',
  props: ['instance']
}
</script>

<style scoped lang="scss">
.v-sheet {
  background-color: white;
  color: black;
}
.msge {
  font-family: 'Poppins', sans-serif!important;
}
.inactive-text {
  font-family: 'Poppins', sans-serif!important;
  font-size: 2.5rem!important;
  line-height: 2.5rem!important;
  text-align: center!important;
  font-weight: 999!important;
  color: black;
}

.btn-text-lowercase {
  font-size: 1rem !important;
  font-weight: 500;
  line-height: 1.25rem;
  letter-spacing: 0.0333333333em !important;
  text-transform: none;
}
.inactive-instance {
  background: white;
  z-index: 5;
  & .linktree {
    z-index: 5000;
  }
}
</style>